
// 开放平台域名
export const OPEN_DOMAIN = location.origin;
// 管理后台域名
export const BACK_END_DOMAIN = window._domain_.backEndDomain;
// 平台面域名
export const MASTER_DOMAIN = window._domain_.masterDomain;
// api域名
export const API_DOMAIN = window._domain_.apiDomain;
// 登录域名
export const LOGIN_DOMAIN = window._domain_.loginDomain

const isCom = window.location.hostname.includes('.com')

let contactQueries =  `${location.origin}/wecode-site/index.html#/wecode/weForm-fill?formId=386953748512137216&answerVersion=10000&lang=zh`
if (location.hostname.includes('clouduat')) {
  contactQueries =  `${location.origin}/wecode-site/index.html#/wecode/weForm-fill?formId=632381362596237312&answerVersion=10000&lang=zh`
} else if (location.hostname.includes('gamma')) {
  contactQueries =   `${location.origin}/wecode-site/index.html#/wecode/weForm-fill?formId=632384081514553344&answerVersion=10000&lang=zh`
}

function getUserInfoApi() {
  let host = window.location.hostname;
  if (host.indexOf("localhost") > -1) return "/welink/sso-service/userinfo";
  let url = window.location.protocol + "//" + host + "/welink/sso-service/userinfo";
  return url;
}

function goLoginURl(url) {
  const newUrl = url.replace(`&target=${encodeURIComponent("开放平台")}`, "");
  const loginUrl = `//${LOGIN_DOMAIN.replace('https://','')}/sso-proxy-front/#/loginenduser?redirect_uri=${encodeURIComponent(newUrl)}&target=开放平台`;
  return loginUrl;
}

/**
 * 红蓝生产测试判断
 * @returns true 表示生产环境 false 表示测试环境
 */
export const isRedBluePro = () => {
  if (location?.hostname?.includes('uat.welink')) {
    return false;
  } else {
    return true;
  }
}



export default {
  goLoginURl: goLoginURl,
  API_CONTEXT: process.env.REACT_APP_API_CONTEXT || "",
  middleUrl: `/${process.env.REACT_APP_API_CONTEXT}/service/isv/market/request-market-service`,
  navMenuApi: `/welink/rest/manage/role/menuResource`,
  loginUserApi: getUserInfoApi(),
  licenseBrandsUrl: `/license/api/v1/brands`,
  solutionsUrl: `/appstore/marketadmin/solutions/v1`,
  selective: `/appstore/marketadmin/selective`,
  ihardwaresAll: `/appstore/marketadmin/ihardwares/v1/all`,
  inquiry: `/appstore/marketadmin/inquiry`,
  uploadFile: `/appstore/marketadmin/images/v1`,
  smartHardwareListUrl: "/appstore/marketadmin/ihardwares/v1/all",
  getHardwaredDetailByIdUrl: "/appstore/marketadmin/ihardwares/v1",
  addSmartHardwaredUrl: "/appstore/marketadmin/ihardwares/v1",
  updateSmartHardwaredUrl: "/appstore/marketadmin/ihardwares/v1",
  deleteSmartHardwaredUrl: "/appstore/marketadmin/ihardwares/v1",
  uploadUrl: `/${process.env.REACT_APP_API_CONTEXT}/form/v1/upload`,
  realnameGuide: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/12ghzs`,
  toRealname: `${BACK_END_DOMAIN}/web/app/#/admintenant/app/to_certified`,
  toMyIsv: `${BACK_END_DOMAIN}/web/app/#/appstore-tenant/app-manage/isv-app`,
  privacyInfo: `/wecode/service/sub-site/api/v1/brands`,
  cryptionApi: `${OPEN_DOMAIN}/docs/obs/resources/cipher/cryptographic.json`,
  trustlistApi: '/wecode/service/apps/tenant/trustlist',
  selectPersonUrl: {
    users: `/useradmin/v1/departments`, // 查询人员
    usersNoPermission: `/useradmin/v1/nopermission/departments`, // 查询人员不分域
    departments: `/useradmin/v1/departments`, // 查询部门
    departmentsNoPermission: `/useradmin/v1/nopermission/departments`, // 查询部门(不分域)
    searchDept: `/useradmin/v1/departments/search`, // 搜索部门
    searchDeptNopermisson: `/useradmin/v1/nopermission/departments/search`, // 搜索部门(不分域)
    searchUser: `/useradmin/v1/users/search`, // 搜索部门下人员
    searchUserNopermission: `/useradmin/v1/nopermission/users/search`, // 搜索部门下人员(不分域)
    roleLIst: `/useradmin/v1/all/roles`, // 查询角色接口
    searchRole: `/useradmin/v1/roles/search` // 搜索角色
  },
  visiblecopeUrl: {
    addPermission: `/weac/admin/v1/visiblescope/authorization`, // 新增授权
    getPermisson: `/weac/admin/v1/visiblescope/commonPermission`, // 获取已有授权
    addPermissionByExcel: `/weac/admin/v1/visiblescope/excelGrantPermission` // 通过excel导入授权
  },
  developDoc: `https://${location.hostname}/docs/#/990hh0/whokyc/kh5tt01`, // 开发文档页面链接
  openPlatformHome: {
    devePlatformHome: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/kh5tt0`, // 开发平台首页
    serverApiDebugTool: `${OPEN_DOMAIN}/apiexplorer/#/apiexplorer?type=internal&method=POST&path=/auth/v2/tickets`, // 服务端API调试工具
    microcodeDeveTool: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/ne0xbw`, // 微码开发工具
    ucdSpecification: `${OPEN_DOMAIN}/docs/#/990hh0/g2r4j4/kuig16`, // UCD规范
    templateCenter: `${OPEN_DOMAIN}/docs/#/990hh0/gdfwyj/ja84d9`, // 模板中心
    secureTunnel: `https://www.huaweicloud.com/product/welink/security.html`, // 安全隧道
    frontEndApiCap: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/9d71zi`, // 前端API能力
    quickAccessWelink: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/s6di0o`, // 快速接入WeLink
    migratApptoMiniProg: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/dxb26p`, // H5迁移应用程序
    viewDeveloptDoc: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/wfwju5`, // 查看开发文档
    enterpriseDeveloper: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/kh5tt0`, // 我是企业开发者
    thirdPartyPartners: `${OPEN_DOMAIN}/docs/#/qdmtm8/uug541/5i3ps5`, // 我是第三方伙伴
    noLoginAuthentication: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/hx3536`, // 免登陆验证
    addressBook: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/kulg01`, // 通讯录
    conferenceServices: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/i2vnm3`, // 会议服务
    weMaxReportingTool: `${BACK_END_DOMAIN}/wemax/introduce.html`, // WeMax报表工具
    notification: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/t9l87h`, // 消息通知
    pendingAccess: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/1mz9xp`, // 待办接入
    approvaForm: `${OPEN_DOMAIN}/wecode-site/index.html#/wecode/form`, // 审批表单
    aiCapabilities: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/5q037x`, // AI能力
    liveService: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/myk0g6`, // 直播服务
    weCodeRadarMonitore: `${OPEN_DOMAIN}/wecode-site/index.html#/wecode/topic?MainRecommendId=303229006847705088`, // We码雷达监控
    richUiComponents: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/4f4op0`, //丰富UI组件
    corporateTravel: `${OPEN_DOMAIN}/wecode-site/index.html#/wecode/topic?MainRecommendId=121763989188255744`, //企业差旅
    cloudSpeedERP: `${OPEN_DOMAIN}/wecode-site/index.html#/wecode/appinfo/20211013155326521885598?groupNam%E7%B2%BE%E9%80%89%E6%8E%A8%E8%8D%90`, // 云速ERP
    redCircleCRM: `${OPEN_DOMAIN}/wecode-site/index.html#/wecode/appinfo/20200120185630417280355?groupNam%E9%94%80%E5%94%AE%E7%AE%A1%E7%90%86`, // 红圈CRM
    contractLock: `${OPEN_DOMAIN}/wecode-site/index.html#/wecode/appinfo/20220118183322265923917`, // 契约锁
    beiDouOKR: `${OPEN_DOMAIN}/wecode-site/index.html#/wecode/appinfo/20210515140750004469745`, // 北斗OKR
    weGo: `${BACK_END_DOMAIN}/approve-build/#/HomeContent` // weGo
  },
  // 头部导航栏链接
  headNavigatUrl: {
    // AppCube应用魔方
    appCubeUrl: "https://developer.huaweicloud.com/activity/weiguangjihua.html",
    // WeMax
    weMaxUrl: `${BACK_END_DOMAIN}/wemax/introduce.html`,
    // We码雷达
    weRadarUrl: `${OPEN_DOMAIN}/wecode-site/index.html#/wecode/topic?MainRecommendId=303229006847705088`,
    // 成为服务商
    becomeAService: `${OPEN_DOMAIN}/docs/#/qdmtm8/7vkemo/qbbjze`,
    // 应用上架WeLink
    appReleaseWeLinkUrl: `${OPEN_DOMAIN}/docs/#/qdmtm8/7vkemo/33j6zb`,
    // 企业内部开发
    enterpriseDevelopmentUrl: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/kh5tt0`,
    // 第三方应用开发
    thirdDevelopmentUrl: `${OPEN_DOMAIN}/docs/#/qdmtm8/uug541/5i3ps5`,
    // 开发工具
    developmentToolsUrl: `${OPEN_DOMAIN}/docs/#/990hh0/whokyc/ne0xbw`,
    // 蒲公英表单
    formWecodeUrl: "#/wecode/form",
    // 飞羽审批
    approvalUrl: `${OPEN_DOMAIN}/wecode-site/index.html#/wecode/approval`,
    // ROMA插件
    romaUrl: '/wecode/roma/romaList',
  },
  appUrl: {
    // 创建应用
    create: `/${process.env.REACT_APP_API_CONTEXT}/service/innerapp/create`,
    // 应用列表
    listByCondition: `/${process.env.REACT_APP_API_CONTEXT}/service/innerapp/listbycondition`,
    // 查询编辑应用详情
    appDetail: `/${process.env.REACT_APP_API_CONTEXT}/service/innerapp`,
  },
  appdevelopment: `${BACK_END_DOMAIN}/wemax/introduce.html`,
  learnZeroCode: "https://www.huaweicloud.com/product/appcube.html",
  // 联系咨询
  contactQueries: contactQueries,
  // 进入购买
  enterToBuy: "https://console.huaweicloud.com/welink/?region=cn-north-4#/welink/order",
  // 进入指定开发者申请页面
  developerPermission: `https://${location.hostname}/docs/#/990hh0/whokyc/ybdos7`,
  DATARANGE: true, // 数据范围的开关，由于通讯录方面未上线，此功能暂不展示
  PRIVACYADDRESS: true, // 隐私地址的开关，此功能暂时不展示 true代表此功能显示 false代表不显示
  permissionNotification: `/wecode/service/online/version`,
  // 数据可视化开发了解更多
  viewLearnMore: `${BACK_END_DOMAIN}/wemax/introduce.html`,
  // 获取飞羽审批二维码
  flyingApprovalCode: 'h5://20190725114925751/html/index.html',
  flyingApprovalVideo: 'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/WeLinkAll/official/Video/1663233588277229006.mp4',// 飞羽审批视频播放地址
  flyingApprovalBuyStandard: 'https://console.huaweicloud.com/welink/?region=cn-north-4#/welinks/order/welink.approval', // 购买飞羽审批标准版
  flyingApprovalBuyFlagship: 'https://console.huaweicloud.com/welink/?region=cn-north-4#/welinks/order/welink.approvalue',  //  购买飞羽审批旗舰版
  cloudFormConfig: `${location.origin}/${process.env.REACT_APP_API_CONTEXT}/form/v1/property?type=cloudFormConfig`,
  openHost: OPEN_DOMAIN,
  // 是否是红蓝环境
  isRedBlue: process.env.REACT_APP_WELINK_ENV === 'redBlue',
  forms: `/${process.env.REACT_APP_API_CONTEXT}/form/v1/forms`,
  _forms: `/${process.env.REACT_APP_API_CONTEXT}/form/v1`,
  questions: `/${process.env.REACT_APP_API_CONTEXT}/form/v1/questions`,
  datastatisticsDetail: `/${process.env.REACT_APP_API_CONTEXT}/form/v1/datastatistics/detail`,
  answersDandelion: `/${process.env.REACT_APP_API_CONTEXT}/form/v1/answers`,
  getJobList: `/${process.env.REACT_APP_API_CONTEXT}/form/v1/forms/job`,
  status: `/${process.env.REACT_APP_API_CONTEXT}/form/v1/forms/status`,
  oneClickReminder: `/${process.env.REACT_APP_API_CONTEXT}/form/v1/forms/notification`,
  answersMeeting: `/${process.env.REACT_APP_API_CONTEXT}/form/v1/meeting/answers`,
  // 投票提交接口
  answersVote: `/${process.env.REACT_APP_API_CONTEXT}/form/v1/vote/answers`,
  personInfo: `/${process.env.REACT_APP_API_CONTEXT}/form/v1/user/info`,
  loginHost: `${process.env.REACT_APP_LOGIN_HOST}/login/logout.do?redirect=`,
  cloudFormConfig: `${location.origin}/${process.env.REACT_APP_API_CONTEXT}/form/v1/property?type=cloudFormConfig`,
  // 是否显示新的开发者后台
  showDeveloperV2: true,
  wemax:`${BACK_END_DOMAIN}/wemax/docs/guide/16.html`

};
